import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ButtonTypeEnum} from '../../enums/button-type.enum';

@Component({
  selector: 'app-button',
  templateUrl: './button.html',
  styleUrl: './button.scss',
  standalone: true
})

export class TemplateBaseButtonIconComponent {
  @Input() icon?: string;
  @Input() label = 'Botão';
  /** Quando true, exibe rótulo compacto para login SSO (estilo primário GovBR DS). */
  @Input() isSsoLogin = false;
  @Input() type: ButtonTypeEnum = ButtonTypeEnum.DEFAULT;
  @Input() disabled: boolean = false;
  @Input() noMargin = false;

  @Output() action = new EventEmitter<void>();

  get classes(): string {
    const margin = this.noMargin ? '' : ' mr-3';
    switch (this.type) {
      case ButtonTypeEnum.PRIMARY:
        return 'br-button primary' + margin;
      case ButtonTypeEnum.SECONDARY:
        return 'br-button secondary' + margin;
      default:
        return 'br-button';
    }
  }

  onClick() {
    if (!this.disabled) {
      this.action.emit();
    }
  }
}
